import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Dropdown, Modal } from 'antd'
import {
  ActionMenu,
  ItemDeleteText,
  ItemText,
  Main,
  SmallButtons,
} from 'components/ActionStyles/ActionStyles'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import { ViewButton } from 'modules/DriveInfo/Styles/style'
import BlacklistDrawer from 'modules/Students/Partials/StudentsInfoTable/BlacklistDrawer'
import ViewStudentDrawer from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer'
import React, { useState } from 'react'
const { confirm } = Modal

const ActionsDriveInfo = ({
  needViewButton = true,
  studentId,
  id,
  getSingleStudentData,
  deleteStudent,
  singleStudentData,
  onEditStudent,
  data,
  UserDriveList,
  blacklistStudent,
  activeInactivateStatus,
  reInviteStudent,
}) => {
  const [viewDrawer, setViewDrawer] = useState(false)
  const [blacklistDrawer, setBlacklistDrawer] = useState(false)
  const [blacklistStudentId, setBlacklistStudentId] = useState('')
  const handleMenuClick = id => {
    setViewDrawer(true)
    getSingleStudentData(id)
  }
  const handleBlacklist = id => {
    setViewDrawer(false)
    setBlacklistDrawer(true)
    setBlacklistStudentId(id)
    getSingleStudentData(id)
  }

  const onDelete = id => {
    deleteStudent(id)
  }
  const showConfirm = id => {
    confirm({
      title: 'Do you want to delete this student?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onDelete(id)
      },
      onCancel() {},
      okText: 'Delete',
    })
  }
  const activateInactivate = (id, currentStatus) => {
    let payload
    if (currentStatus == 2) {
      payload = {
        status: -2,
      }
    } else {
      payload = {
        status: 2,
      }
    }

    activeInactivateStatus(id, payload)
  }
  const handleInvite = data => {
    reInviteStudent(data.id)
  }

  const menu = (
    <ActionMenu
      width={'165px'}
      items={[
        {
          key: 'edit',
          label: <ItemText>Edit Profile</ItemText>,
          onClick: () => onEditStudent(studentId),
        },
        {
          key: 'invite',
          label: 'Resend Invite',
          onClick: () => handleInvite(data),
          disabled: data.status != 0,
        },
        {
          key: 'blacklist',
          label:
            data?.status == -1 ? 'Blacklist' : <ItemText>Blacklist</ItemText>,
          onClick: () => handleBlacklist(studentId),
          disabled: data?.status == -1,
        },
        {
          key: 'active',
          label: data?.status == 2 ? 'Inactivate' : 'Activate',
          disabled:
            data?.status == 0 || data?.status == -3 || data?.status == -1,
          onClick: () => activateInactivate(studentId, data?.status),
        },
        {
          type: 'divider',
        },
        {
          key: 'delete',
          label: <ItemDeleteText>Delete Student</ItemDeleteText>,
          onClick: () => showConfirm(studentId),
        },
      ]}
    />
  )

  return (
    <>
      {needViewButton ? (
        <Main>
          <ViewButton
            onClick={() => handleMenuClick(id)}
            style={{ borderColor: 'primary', cursor: 'pointer' }}
          >
            View
          </ViewButton>
          {}
        </Main>
      ) : (
        <Dropdown overlay={menu} trigger={['click']}>
          <a onClick={e => e.preventDefault()} href="/">
            <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
          </a>
        </Dropdown>
      )}
      {singleStudentData?.firstName ? (
        <ViewStudentDrawer
          viewDrawer={viewDrawer}
          setViewDrawer={setViewDrawer}
          singleStudentData={singleStudentData}
          deleteStudent={onDelete}
        />
      ) : null}

      <BlacklistDrawer
        blacklistDrawer={blacklistDrawer}
        setBlacklistDrawer={setBlacklistDrawer}
        singleStudentData={singleStudentData}
        blacklistStudent={blacklistStudent}
        blacklistStudentId={blacklistStudentId}
      />
    </>
  )
}

export default ActionsDriveInfo
